import { createActionGroup, props } from '@ngrx/store';
import { DaveMutationDeleteTrustedDeviceArgs } from '../../graphql-types';
import { TrustedDeviceEntity } from '../../entities/trusted-device.entity';

export const TrustedDeviceActions = createActionGroup({
    source: 'TrustedDevices',
    events: {
        'LoadRequest': props<{ Payload: {} }>(),
        'LoadSuccess': props<{ Payload: TrustedDeviceEntity[] }>(),
        'LoadFailure': props<{ Payload: {Err: any;} }>(),

        'DeleteRequest': props<{ Payload: DaveMutationDeleteTrustedDeviceArgs }>(),
        'DeleteSuccess': props<{ Payload: number }>(),
        'DeleteFailure': props<{ Payload: {Err: any;} }>(),
    },
});
